export default class Validate {
    constructor(form) {
        this.form = $(form);
        this.inputs = this.form.find("input, select, textarea");
        this.required = this.form.find("[data-required]");
        this.email = this.form.find("[data-email]");
        this.minlength = this.form.find("[data-minlength]");
        this.fileformat = this.form.find("[data-fileformat]");
        this.submitBtn = this.form.find("[data-submit]");
        this.messagesEn = window.validateMessages;
        this.messagesRu = {
            required: "Не заполнено поле",
            minlength: "Не менее %min% символов",
            email: "Неправильный формат",
            fileformat: "Недопустимый тип файла",
            filesize: "Файл должен быть до %max% МБ",
        };
        /**
            Так как могут быть поля обязательные,
            но ещё не проверенные, приходится вводить
            для них дополнительный класс
        */
        this.form
            .find("[data-required]")
            .not(":checkbox")
            .addClass("_notvalidated");
        // для обязательных чекбоксов только те, что не отмечены по умолчанию
        this.form
            .find(":checkbox[data-required]")
            .not(":checked")
            .addClass("_notvalidated");

        this.handleChange();
    }

    handleChange() {
        const eventName = App.ie ? "change blur" : "change";

        this.inputs.on(eventName, (e) => {
            const $input = $(e.target);

            this.validateField($input);
        });
    }

    validateAllFields() {
        this.inputs.each((index, el) => {
            const $input = $(el);

            this.validateField($input);
        });
    }

    validateField($input) {
        // Запускаем проверки
        if ($input.is(":checkbox[data-required]")) {
            this.validateRequiredCheckbox($input);
        } else if ($input.is("[data-required]")) {
            this.validateRequired($input);
        }

        if ($input.is("[type=email]") || $input.is("[data-email]")) {
            this.validateEmail($input);
        }

        if ($input.is("[data-minlength]")) {
            this.validateMinLength($input);
        }

        if ($input.is("[data-fileformat]")) {
            this.validateFileFormat($input);
        }

        /*if ( $input.is('[data-filesize]') ) {
            this.validateFileSize($input);
        }*/

        /**
         Теперь поле либо валидно, либо у него
         есть класс _error, и ложной разблокировки
         кнопки сабмита не будет
         */
        $input.removeClass("_notvalidated");

        // Считаем ошибки
        this.isValid();
    }

    validateRequired($input) {
        // Проверяем обязательные поля
        const $inputWrap = $input.closest(".js-input-wrap");
        const $label = $input.siblings("[data-label]");
        const val = $input.val().replace(/\s/g, "");
        const lang = $("html")[0].lang;

        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        if (val.length > 0) {
            $inputWrap.removeClass("_error");
            $input.removeClass("_error");
            $label.text("");
        } else {
            $input.addClass("_error");
            $inputWrap.addClass("_error");
            if (lang === "en") {
                $label.text(this.messagesEn.required);
            }
            if (lang === "ru") {
                $label.text(this.messagesRu.required);
            }
        }
    }

    validateRequiredCheckbox($input) {
        // Проверяем обязательные чекбоксы
        const $inputWrap = $input.closest(".js-input-wrap");
        const $label = $input.parent().siblings("[data-label]");
        const lang = $("html")[0].lang;

        if ($input.is(":checked")) {
            $inputWrap.removeClass("_error");
            $input.removeClass("_error");
            $label.text("");
        } else {
            $inputWrap.addClass("_error");
            $input.addClass("_error");
            lang === "ru"
                ? $label.text(this.messagesRu.required)
                : $label.text(this.messagesEn.required);
        }
    }

    validateMinLength($input) {
        // Проверяем минимальное количество символов

        const $label = $input.siblings("[data-label]");
        const min = $input.data("minlength");
        const val = $.trim($input.val());

        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        if (val.length >= min) {
            // Достаточно символов

            $input.removeClass("_error");
            $label.text("");
        } else if (val.length > 0) {
            // Недостаточно символов
            const lang = $("html")[0].lang;

            const phoneMaskSimbols = $input.is("#phone") ? 5 : 0;

            const message =
                lang === "ru"
                    ? this.messagesRu.minlength.replace("%min%", min - phoneMaskSimbols)
                    : this.messagesEn.minlength.replace("%min%", min - phoneMaskSimbols);

            $input.addClass("_error");
            $label.text(message);
        } else if (val.length == 0 && $input.is(":not([data-required])")) {
            // Поле пустое и необязательное

            /**
                Если оно обязательное, в этом случае за него
                будет отвечать validateRequired()
            */

            $input.removeClass("_error");
            $label.text("");
        }
    }

    validateEmail($input) {
        // Проверяем email
        const $inputWrap = $input.closest(".js-input-wrap");
        const $label = $input.siblings("[data-label]");
        const val = $input.val().replace(/\s/g, "");

        /**
            Если поле пустое, то не валидируем его,
            оставляем эту работу для validateRequired()
        */

        if (!val.length) return;

        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        if (
            /^[a-z0-9](\.?[a-z0-9_-]){0,}@[a-z0-9-]+\.([a-z]{1,6}\.)?[a-z]{2,6}$/i.test(
                val
            )
        ) {
            $inputWrap.removeClass("_error");
            $input.removeClass("_error");
            $label.text("");
        } else {
            $inputWrap.addClass("_error");
            $input.addClass("_error");
            const lang = $("html")[0].lang;

            lang === "ru"
                ? $label.text(this.messagesRu.email)
                : $label.text(this.messagesEn.email);
        }
    }

    validateFileFormat($input) {
        // Проверяем расширение файла
        const $inputWrap = $input.closest(".js-input-wrap");
        const $label = $input.siblings("[data-label]");
        const accept = $input.attr("accept").split(",");
        const val = $input.val();
        const lang = $("html")[0].lang;

        /**
            Если поле пустое, то не валидируем его,
            оставляем эту работу для validateRequired()
        */

        if (!val.length && $input.is("[data-required]")) {
            return;
        } else if (!val.length) {
            $inputWrap.removeClass("_error");
            $input.removeClass("_error");
            $label.text("");
            return;
        }

        /**
            Убираем или подставляем класс _error,
            а также текст об ошибке
        */

        let ext = "." + val.split(".").pop();
        ext = ext.toLowerCase();

        if ($.inArray(ext, accept) > -1) {
            $inputWrap.removeClass("_error");
            $input.removeClass("_error");
            $label.text("");

            /**
                Если формат файла ОК, после этого
                проверяем размер файла
            */
            if ($input.is("[data-filesize]")) {
                this.validateFileSize($input);
            }
        } else {
            $inputWrap.addClass("_error");
            $input.addClass("_error");
            lang === "ru"
                ? $label.text(this.messagesRu.fileformat)
                : $label.text(this.messagesEn.fileformat);
        }
    }

    validateFileSize($input) {
        // Проверяем размер загруженного файла
        const $inputWrap = $input.closest(".js-input-wrap");
        const $label = $input.siblings("[data-label]");
        const max = +$input.data("filesize");
        const lang = $("html")[0].lang;

        if ($input[0].files.length) {
            const size = $input[0].files[0].size / 1024 / 1024;

            if (size > max) {
                const message =
                    lang === "ru"
                        ? this.messagesRu.filesize.replace("%max%", max)
                        : this.messagesEn.filesize.replace("%max%", max);
                $inputWrap.addClass("_error");
                $input.addClass("_error");
                $label.text(message);
            }
        }
    }

    isValid() {
        // Подводим итоги проверок
        const lang = $("html")[0].lang;
        const errors = this.form.find("._error, ._notvalidated").length;
        // if (errors > 0) {
        //     this.submitBtn.attr('disabled', true);
        // } else {
        //     this.submitBtn.removeAttr('disabled');
        // }

        
        return errors === 0;
    }
}



// WEBPACK FOOTER //
// ./_src/js/Validate.js